export function isNonNumeric(e: React.KeyboardEvent<HTMLInputElement>) {
  return e.key.length === 1 && isNaN(+e.key) && !e.ctrlKey;
}
